import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-toggle',
  templateUrl: './header-toggle.component.html',
  styleUrls: ['./header-toggle.component.scss']
})
export class HeaderToggleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
